/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
// console.log("Hello World! (from create-block-ew-transaprent-mockups block)");
/* eslint-enable no-console */

import { gsap } from "gsap";

// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event){

	console.log("DOM loaded");

	//wait until images, links, fonts, stylesheets, and js is loaded
	window.addEventListener("load", function(e) {
		console.log("window loaded");

		let mockups_tl = gsap.timeline({repeat:-1});

		mockups_tl.set(".ew-mockup__slide", {rotateY: 80})
			.to(".ew-mockup__slide",
			{
				rotateY: 20,
				duration: .2,
				opacity: 1
				// ease: "power1.inOut"
			}).to(".ew-mockup__slide",{
				rotateY: -20,
				duration: 2.6
			}).to(".ew-mockup__slide", {
				rotateY: -80,
				duration: .2,
				opacity: 0
				// ease: "power1.inOut"
			});
		// mockups_tl.to(".ew-mockup__slide", {rotateY: 80, duration: 0});
		// mockups_tl.to(".ew-mockup__slide", {delay: 1});

	});
});

